import { Meta } from "@/shared/components";
import { Organizations } from "@/admin/features/organizations";

export function OrganizationsPage() {
  return (
    <>
      <Meta title="Пользователи" />
      <Organizations />
    </>
  );
}
